import { render, staticRenderFns } from "./PreviewLetterPage.vue?vue&type=template&id=5132392b&scoped=true&"
import script from "./PreviewLetterPage.vue?vue&type=script&lang=js&"
export * from "./PreviewLetterPage.vue?vue&type=script&lang=js&"
import style0 from "./PreviewLetterPage.vue?vue&type=style&index=0&id=5132392b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5132392b",
  null
  
)

export default component.exports